import Vue from 'vue'
import App from './App.vue'
import '@/font/icon/iconfont.css'
import  '@/font/font.css'
import animated from 'animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'


axios.defaults.baseURL = 'http://nevzht.y47.net/';
Vue.prototype.$axios = axios
Vue.prototype.$picUrl = 'http://nevzht.y47.net/'


Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.use(animated)

new Vue({
  render: h => h(App)
}).$mount('#app')
